const getSelectedOptIns = (changedOptIns = {}) => Object.entries(changedOptIns).reduce((acc, [key, optIn]) => {
  if (optIn.checked) {
    return [...acc, key];
  }
  return acc;
}, []);
export {
  getSelectedOptIns
};
//# sourceMappingURL=get-selected-opt-ins.js.map
